import { useGetHealthAppStepQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType } from "utils/helper";
import { getProspectUuid } from "utils/idHelpers";
import HealthApplicationStatus from "./HealthApplicationStatus";

const HealthApplicationStatusModel = (): JSX.Element => {
  const { data, error, loading } = useGetHealthAppStepQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error || data?.prospect?.applications?.[0]?.step !== 9) {
    return <ErrorPage />;
  }

  return (
    <>
      {data?.prospect?.applications?.[0]?.step === 9 && (
        <HealthApplicationStatus />
      )}
    </>
  );
};
export default HealthApplicationStatusModel;
